import { AuthenticationFactory } from './auth/AuthenticationFactory';
import { initializeAuthService } from './auth/services/authService';

export async function initializeAuth() {
  try {
    const authPort = await AuthenticationFactory.create();
    
    initializeAuthService(authPort);
    
    console.log('[Auth Bootstrap] Successfully initialized authentication port');
    return authPort;
  } catch (error) {
    console.error('[Auth Bootstrap] Failed to initialize:', error);
    throw error;
  }
}
